var partners = document.getElementById('partners');

if (partners) {
    var GoogleMapsLoader = require('google-maps');
    var partnersMap = document.getElementById('partners-map');

    GoogleMapsLoader.KEY = partnersMap.getAttribute('data-api-key');
    GoogleMapsLoader.LANGUAGE = 'lt';
    GoogleMapsLoader.REGION = 'LT';

    GoogleMapsLoader.load(function(google) {
        var markers = getPartnersMarkers();
        var lithuaniaLatLng = {lat: 55.1736, lng: 23.883296};
        var options = {
            zoom: 7,
            center: lithuaniaLatLng
        };

        var map = new google.maps.Map(partnersMap, options);

        google.maps.event.addDomListener(window, 'resize', function() {
            map.setCenter(lithuaniaLatLng);
        });

        addPartnersMarkers(map, markers);
    });

    function getPartnersMarkers() {
        var partnersShops = partners.getElementsByClassName('partners__shop');
        var markers = [];

        for (var i = 0; i < partnersShops.length; i++) {
            var infoWindowContent = '<p><b>' +
                partnersShops[i].getAttribute('data-shop-title') +'</b><br/>' +
                partnersShops[i].getAttribute('data-shop-address') + '<br/>';

            if (partnersShops[i].getAttribute('data-shop-phone')) {
                infoWindowContent += partnersShops[i].getAttribute('data-shop-phone') + '<br/>';
            }

            if (partnersShops[i].getAttribute('data-shop-email')) {
                infoWindowContent += partnersShops[i].getAttribute('data-shop-email') + '<br/>';
            }

            infoWindowContent += '</p>';

            markers[markers.length] = [
                partnersShops[i].getAttribute('data-shop-title'),
                parseFloat(partnersShops[i].getAttribute('data-shop-latitude')),
                parseFloat(partnersShops[i].getAttribute('data-shop-longitude')),
                infoWindowContent
            ];
        }

        return markers;
    }

    function addPartnersMarkers(map, markers) {
        var infowindow = new google.maps.InfoWindow();
        var marker = null;

        for (var i = 0; i < markers.length; i++) {
            var markerLocation = {
                lat: markers[i][1],
                lng: markers[i][2]
            };

            marker = new google.maps.Marker({
                position: markerLocation,
                map: map,
                title: markers[i][0]
            });

            google.maps.event.addListener(marker, 'click', (function(marker, i) {
                return function() {
                    infowindow.setContent(markers[i][3]);
                    infowindow.open(map, marker);
                }
            })(marker, i));
        }
    }
}
